import InternalServerErrorImage from "assets/images/internal-server-error";
import PageNotFoundImage from "assets/images/page-not-found";
import UnauthorizedImage from "assets/images/unauthorized";

export const ERRORS = {
  404: {
    Image: PageNotFoundImage,
    errorKey: "neetoMolecules.errorPage.cantBeFound",
    titleKey: "neetoMolecules.errorPage.title.cantBeFound",
  },
  403: {
    Image: UnauthorizedImage,
    errorKey: "neetoMolecules.errorPage.unauthorized",
    titleKey: "neetoMolecules.errorPage.title.unauthorized",
  },
  500: {
    Image: InternalServerErrorImage,
    errorKey: "neetoMolecules.errorPage.internalServerError",
    titleKey: "neetoMolecules.errorPage.title.internalServerError",
  },
};
